import type { ICandidate, IExperienceFlat } from "@bbj-types/candidate";
import type { Override } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosV2 } from "./axios";

export type IPatchCandidate = Partial<
  Override<
    Omit<
      ICandidate,
      "_id" | "profileId" | "applicationFiles" | "cer" | "organisation" | "createdAt" | "updatedAt" | "documents"
    >,
    {
      authors: string[];
      experiences: IExperienceFlat[];
      skills?: string[];
      team: string | null;
      trainingLevel: number | null;
    }
  >
>;

export const usePatchCandidate = () => {
  const [state, execute, cancel] = axiosV2<ICandidate, IPatchCandidate, unknown>(
    {
      url: "/candidates",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string, data: IPatchCandidate) => {
      return execute({
        url: `/candidates/${id}`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
